import React from 'react';

type props = {
  heading: String;
};

const Heading: React.FunctionComponent<props> = ({ heading }): JSX.Element => {
  return (
    <div>
      <div className="w-12/12 gray-border-line relative ml-7 flex border-b pt-3">
        <p className="text-gray-light text-xxs text-center font-bold">{heading.toUpperCase()}</p>
      </div>
    </div>
  );
};

export default Heading;
